var _g, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHomeBannerBg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 947,
    viewBox: "0 0 1440 947",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4,
    filter: "url(#filter0_f_401_19)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M674 138.5C674 258.622 413.852 233 220 233C26.1481 233 -28 258.622 -28 138.5C-28 18.3781 129.148 -79 323 -79C516.852 -79 674 18.3781 674 138.5Z",
    fill: "#E61F82"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_401_19)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1309.73 510.063C1156.94 613.128 1213.01 740.885 1140.42 690.972C1067.84 641.058 1077.75 500.622 1162.55 377.298C1247.36 253.974 1374.95 194.463 1447.53 244.376C1520.12 294.29 1462.53 406.998 1309.73 510.063Z",
    fill: "#3EBEDB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_401_19",
    x: -452,
    y: -503,
    width: 1550,
    height: 1162.29,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 212,
    result: "effect1_foregroundBlur_401_19"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_401_19",
    x: 847.858,
    y: -17.2832,
    width: 874.834,
    height: 963.413,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 122,
    result: "effect1_foregroundBlur_401_19"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeBannerBg);
export default __webpack_public_path__ + "static/media/homeBannerBG.8f0e465be8e49aebedceb3168d0e6432.svg";
export { ForwardRef as ReactComponent };